import classNames from "classnames";
import { Typography } from "@circle-react-uikit/Typography";
import { CheckIcon } from "./CheckIcon";

interface StringFeatureProps {
  className?: string;
  hideCheckIcon?: boolean;
  value: string;
}

export const StringFeature = ({
  value,
  hideCheckIcon = false,
  className,
}: StringFeatureProps) => (
  <div className={classNames("flex items-center", className)}>
    {!hideCheckIcon && <CheckIcon />}
    <Typography.BodyMd color="text-default">{value}</Typography.BodyMd>
  </div>
);
